module.exports = __webpack_public_path__ + "static/media/HARTVIG TURNTABLE.7295f1ab.png";